import { render, staticRenderFns } from "./HomeWelcomeMessage.vue?vue&type=template&id=37ab22dc&scoped=true&"
import script from "./HomeWelcomeMessage.vue?vue&type=script&lang=js&"
export * from "./HomeWelcomeMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ab22dc",
  null
  
)

export default component.exports